import { Injectable } from '@angular/core';
import { Observable, Subject, forkJoin } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';

import { CompetencesEndpoint } from './competences-endpoint.service';
import { AuthService } from './auth.service';
import { Competence } from '../models/competence.model';


@Injectable()
export class CompetencesService {

  constructor(
    private authService: AuthService,
    private competencesEndpoint: CompetencesEndpoint) {
  }

  createCompetence(competence: Competence) {
    return this.competencesEndpoint.createCompetenceEndpoint<Competence>(competence);
  }

  updateCompetence(competenceId: number, competence: Competence) {
    return this.competencesEndpoint.updateCompetenceEndpoint<Competence>(competenceId, competence);
  }

  deleteCompetence(competenceId: number) {
    return this.competencesEndpoint.deleteCompetenceEndpoint<Competence>(competenceId);
  }

  competenceExist(code: string) {
    return this.competencesEndpoint.competenceExistEndpoint<Array<Competence>>(code);
  }

  numeroCompetenceExist(numero: number, programmeId: number, competenceId: number) {
    var params = new Array();
    params[0] = numero.toString();
    params[1] = programmeId.toString();
    params[2] = competenceId.toString();
    return this.competencesEndpoint.numeroCompetenceExistEndpoint<boolean>(params);
  }

}
